/* ==========================================================================
   ASJ CUSTOM - Desktop header navigation enhancement (nested "Buy" dropdown).
   Progressive enhancement of Dawn's native <header-menu> disclosure menus:
   - Hover intent: hovering a top-level item (Gas/Diesel/Oils) opens its
     dropdown; hovering "Buy" opens the nested submenu. Menus close after a
     short delay so the pointer can travel into the submenu without it
     vanishing. Native click/Enter toggling is preserved for keyboard, touch
     and no-hover devices.
   - Link-through: a summary with data-asj-url (from Shopify Navigation)
     navigates when its menu is ALREADY open (hover users: first click;
     click users: second activation). Placeholder "#" URLs never navigate.
   - Escape closes the innermost open menu and returns focus to its toggle.
   All labels/URLs come from Shopify Navigation. Desktop only (>=990px);
   the mobile drawer is handled by asj-mobile-menu.js. Safe to remove.
   ========================================================================== */
(function () {
  'use strict';

  var DESKTOP = window.matchMedia('(min-width: 990px)');
  var CAN_HOVER = window.matchMedia('(hover: hover) and (pointer: fine)');
  var CLOSE_DELAY = 300;

  function summaryOf(details) {
    return details.querySelector(':scope > summary');
  }

  function setOpen(details, open) {
    if (open) {
      details.setAttribute('open', '');
    } else {
      details.removeAttribute('open');
      details.querySelectorAll(':scope details[open]').forEach(function (d) {
        d.removeAttribute('open');
        var ns = summaryOf(d);
        if (ns) ns.setAttribute('aria-expanded', 'false');
      });
    }
    var s = summaryOf(details);
    if (s) s.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeSiblingTopMenus(current) {
    document.querySelectorAll('.header__inline-menu header-menu > details[open]').forEach(function (d) {
      if (d !== current) setOpen(d, false);
    });
  }

  function bindHover(scope, details, isTop) {
    var timer = null;
    scope.addEventListener('pointerenter', function (e) {
      if (!DESKTOP.matches || !CAN_HOVER.matches || e.pointerType === 'touch') return;
      if (timer) { clearTimeout(timer); timer = null; }
      if (isTop) closeSiblingTopMenus(details);
      if (!details.hasAttribute('open')) setOpen(details, true);
    });
    scope.addEventListener('pointerleave', function (e) {
      if (!DESKTOP.matches || !CAN_HOVER.matches || e.pointerType === 'touch') return;
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        setOpen(details, false);
        timer = null;
      }, CLOSE_DELAY);
    });
  }

  function bindLinkThrough(summary, details) {
    var url = summary.getAttribute('data-asj-url');
    if (!url || url === '#') return;
    summary.addEventListener('click', function (e) {
      if (details.hasAttribute('open')) {
        e.preventDefault();
        window.location.href = url;
      }
    });
  }

  function bindEscape(details) {
    details.addEventListener('keyup', function (e) {
      if (e.key !== 'Escape') return;
      var inner = details.querySelector('details[open]');
      var target = inner || details;
      if (!target.hasAttribute('open')) return;
      e.stopPropagation();
      setOpen(target, false);
      var s = summaryOf(target);
      if (s) s.focus();
    });
  }

  function initTop(headerMenu) {
    var details = headerMenu.querySelector(':scope > details');
    if (!details || details.dataset.asjNav) return;
    details.dataset.asjNav = '1';
    bindHover(headerMenu, details, true);
    bindEscape(details);
    var s = summaryOf(details);
    if (s) bindLinkThrough(s, details);
  }

  function initNested(details) {
    if (details.dataset.asjNav) return;
    details.dataset.asjNav = '1';
    var scope = details.closest('li') || details;
    bindHover(scope, details, false);
    var s = summaryOf(details);
    if (s) {
      s.setAttribute('aria-expanded', details.hasAttribute('open') ? 'true' : 'false');
      bindLinkThrough(s, details);
    }
    details.addEventListener('toggle', function () {
      var ns = summaryOf(details);
      if (ns) ns.setAttribute('aria-expanded', details.hasAttribute('open') ? 'true' : 'false');
    });
  }

  function boot() {
    document.querySelectorAll('.header__inline-menu header-menu').forEach(initTop);
    document
      .querySelectorAll('.header__inline-menu details[id^="Details-HeaderSubMenu-"]')
      .forEach(initNested);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
